import { Content, Horizontal, StretchSpacer, Vertical } from "gls/lib";
import React from "react";
import { useTranslation } from "react-i18next";
import { style, stylesheet } from "typestyle";
import { Colours, fontFamily, Sizes } from "../../styles";
import { Form } from "../Form/Form";
import { FormTextInput } from "../Form/FormTextInput";
import { FormState } from "../Form/types";
import { isMandatory } from "../Form/validators/isMandatoryValidator";

export interface TotpSetupLoginProps {
  secret: string;
  onSubmit: (code: string) => void;
  onBackToLogin?: () => void;
}

export const TotpSetupLogin: React.FC<TotpSetupLoginProps> = ({
  secret,
  onSubmit,
  onBackToLogin,
}) => {
  const { t } = useTranslation();
  const onSubmitHandler = ({ code }: FormState) => {
    onSubmit(code.value.trim());
  };

  return (
    <Vertical
      width={300}
      spacing={15}
      className={style({ fontFamily: fontFamily })}
      data-testid="login-totp-setup"
    >
      <Form
        title={t("Set up two-factor authentication")}
        onSubmit={onSubmitHandler}
        submitButtonText={t("Verify")}
      >
        <Content>
          {t(
            "Add this key to an authenticator app such as Google Authenticator, then enter the code it shows.",
          )}
        </Content>
        <Content className={classNames.secret} data-testid="totp-secret">
          {secret}
        </Content>
        <FormTextInput
          name="code"
          label={t("Authenticator code")}
          validators={[isMandatory]}
        />
      </Form>
      {onBackToLogin && (
        <Horizontal>
          <StretchSpacer />
          <Content
            horizontalAlign="right"
            className={classNames.backLabel}
            onClick={() => onBackToLogin?.()}
          >
            {t("Back to login")}
          </Content>
        </Horizontal>
      )}
    </Vertical>
  );
};

const classNames = stylesheet({
  secret: {
    fontFamily: "monospace",
    wordBreak: "break-all",
    userSelect: "all",
    padding: "0.65rem",
    border: `1px solid ${Colours.textDark}`,
  },
  backLabel: {
    color: Colours.textDark,
    cursor: "pointer",
    fontSize: Sizes.fontSize1,
    $nest: {
      "&:hover": {
        color: Colours.textLight,
      },
    },
  },
});
